import { useI18n } from '../i18n';
import pageThemeStyles from '../components/menuPageTheme.module.css';

export function AssistantSearchSlotChip({ text }: { text: string | null | undefined }) {
  const { t } = useI18n();
  const chip = text?.trim() ?? '';
  if (!chip) {
    return null;
  }
  return (
    <span
      className={pageThemeStyles.assistantSlotChip}
      title={chip}
      aria-label={t('assistant.slot.chipAria', { chip })}
    >
      {chip}
    </span>
  );
}
